import { SectionCardProps } from './SectionCard.types';
import * as Styled from './SectionCard.styles';

/** The white, 1px-bordered, 8px-radius panel every DOD surface is built from. */
export const SectionCard = ({ title, actions, children, className, bodyHeight }: SectionCardProps): JSX.Element => (
  <Styled.Card className={className}>
    {(title || actions) && (
      <Styled.Header>
        {title && <Styled.Title>{title}</Styled.Title>}
        {actions && <Styled.Actions>{actions}</Styled.Actions>}
      </Styled.Header>
    )}
    <Styled.Body $height={bodyHeight}>{children}</Styled.Body>
  </Styled.Card>
);
